<template>
  <div class="listable-head">
    <div
      v-for="(column, i) in activeColumns"
      :key="i"
      class="th"
      :class="{ 'd-none': i > 2 && hasDetailsPane }"
    >
      <span v-if="hideMenus" class="text">{{ column.label }}</span>
      <ContextMenu
        v-else
        :id="`col-${i}`"
        :items="columnsMenu(i)"
        :align="i == activeColumns.length - 1 ? 'right' : 'left'"
      >
        <template slot="default">
          <span class="text">{{ column.label }}</span>
          <span class="icon icon-arrow-down"></span>
        </template>
        <template v-if="!!column.sortable" slot="menu-before">
          <a
            class="dropdown-item"
            href="#"
            @click.prevent="$emit('sort-by', column, 'asc')"
            >Sort Ascending</a
          >
          <a
            class="dropdown-item"
            href="#"
            @click.prevent="$emit('sort-by', column, 'desc')"
            >Sort Descending</a
          >
        </template>
      </ContextMenu>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    columns: { type: Array, required: true },
    active: { type: Array, required: true },
    swappable: { type: Boolean, default: true },
    hasDetailsPane: { type: Boolean, default: false },
    hideMenus: { type: Boolean, default: false },
  },
  computed: {
    activeColumns() {
      let activeColumns = [];
      this.active.forEach((slug) => {
        var column = this.columns.find((c) => c.key == slug);
        activeColumns.push(column);
      });
      return activeColumns;
    },
  },
  methods: {
    columnsMenu(col) {
      if (!this.swappable) {
        return [];
      }

      return this.columns
        .map((c) => {
          return {
            label: c.label,
            action: () => {
              this.$emit("swap-column", c.key, col);
            },
          };
        })
        .sort((a, b) => {
          if (a.label == b.label) {
            return 0;
          }
          return a.label < b.label ? -1 : 1;
        });
    },
  },
};
</script>
